import { HeaderNavComponent } from "./header-nav-compontent"
import { useLocation } from 'react-router-dom'
import { CheckCircleIcon, XCircleIcon } from '@heroicons/react/24/outline'


export const CheckoutComponent = () => {
    const { search } = useLocation()
    const paymentSuccess = new URLSearchParams(search).get('payment_success') === 'true'
    const isGuest = new URLSearchParams(search).get('is_guest') === 'true'
    return (
        <div className="min-h-screen px-4">
            <HeaderNavComponent />
            <div className="p-8 text-center">
                {paymentSuccess ? (
                    <>
                        <CheckCircleIcon className="h-24 w-24 text-green-500 mx-auto" />
                        <h2 className="mt-6 text-2xl font-bold text-gray-800">
                            Thank you for your purchase!
                        </h2>
                        {isGuest && (
                            <p className="mt-4 text-gray-600">
                            Your temporary login credentials have been emailed to you. Don&apos;t forget to change your password.
                        </p>
                        )}
                    </>
                ) : (
                    <>
                        <XCircleIcon className="h-24 w-24 text-red-500 mx-auto" />
                        <h2 className="mt-6 text-2xl font-bold text-gray-800">
                            Oops! Something went wrong.
                        </h2>
                        <p className="mt-4 text-gray-600">
                            Payment failed. Please try again or contact support @ <a className="text-blue-500" href="mailto:tristan@pocket-quant.com">tristan@pocket-quant.com</a>.
                        </p>
                    </>
                )}
            </div>
        </div>
    )
}